import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/w/$workspaceSlug/organizations/')({
  staticData: {
    pageName: 'Organizations',
  },
  beforeLoad: () => {
    throw redirect({ to: '/organizations', replace: true });
  },
});
